// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X0JhqOgbj4I4EknfUkUr{flex-direction:column;gap:24px;width:100%;display:flex}.dySvaJ2fs2YV_JJyc_d7{justify-content:flex-end;gap:8px;width:100%;padding-top:8px;display:flex}.wmbM9LYHykctSjheWhTJ{cursor:pointer;-webkit-user-select:none;user-select:none;align-items:center;gap:8px;display:inline-flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `X0JhqOgbj4I4EknfUkUr`,
	"actions": `dySvaJ2fs2YV_JJyc_d7`,
	"wrapCheckbox": `wmbM9LYHykctSjheWhTJ`
};
export default ___CSS_LOADER_EXPORT___;
